<template>
  <el-dialog
    :visible.sync="isShowDialog" class="dialog-square"
    :title="$t('common.setting')" center width="400px"
    :close-on-click-modal="false" @close="close">
    <div class="dialog-con df-l-c-fs w100p">
      <div class="dialog-ctr w100p">

        <div class="mydialog df-l-fs">
          <div class="row df-c-sb" v-for="(x,i) in bookDays" :key="i" @click="x.openBookTime&&!x.passed&&dateSelect(i)">
            <div class="f-m _themecolor" :class="{'_cc':!x.openBookTime||x.passed}">{{x.bookDateTime}}</div>
            <img style="width:20px;height:20px;" mode="aspectFill" :src="i===index?iconCheckok2:iconChecknull2" v-if="x.openBookTime&&!x.passed" />
          </div>
        </div>
          
      </div>
      <div class="dialog-btm w100p df-c-sa">
        <div :class="index===''?'whitebtn':'themebtn'" @click="submit">{{$t('common.comfirm')}}</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogTime',
  data() {
    return {
      isShowDialog: false,
      bookDays: [],
      index: '',
    }
  },
  methods: {
    open() {
      this.initPage()
      this.scan_canLeave_x_save(false)
      this.isShowDialog = true
    },
    close() {
      this.scan_canLeave_x_save(true)
      this.isShowDialog = false
      this.index = ''
    },
    dateSelect(index) {
      this.index = index
    },
    submit() {
      this.$emit('update:count', this.bookDays[this.index].bookDateTime)
      this.close()
    },
    initPage() {
      this.bookDays = []
      const { advanceDay, maxTime } = this.bookConfig_m
      const NOW = new Date().getTime()

      let flag = false
      
      let ARR = JSON.parse(JSON.stringify(this.bookConfig_m.bookTimeList))
      ARR[ARR.length - 1].end = true

      for (let i = advanceDay; i <= maxTime; i++) {
        ARR.forEach(x1 => {
          x1.n = i
          x1.passed = false
          this.bookDays.push(JSON.parse(JSON.stringify(x1)))
        })
      }

      console.log(`%cthis.bookDays:`, 'color: #00f;', this.bookDays)

      for (let i = 0; i < this.bookDays.length; i++) {
        const x = this.bookDays[i]
        const today = this.$tool.time_parse_ymd(this.$tool.time_get_dateObj_after_n_day(x.n))
        const tomorrow = this.$tool.time_parse_ymd(this.$tool.time_get_dateObj_after_n_day(x.n + 1))
        // console.log(x.n, x.end, today, tomorrow)
        if (i === 0) {
          x.bookDateTime = today + ' ' + x.bookDate
        } else {
          const prev = this.bookDays[i - 1]
          const isMin = Number(x.bookDate.replace(/:/g, '')) < Number(prev.bookDate.replace(/:/g, ''))
          // if (!isMin || prev.end) {
          //   prev.end && (flag = false)
          // } else {
          //   // 这个点开始跨天了
          //   flag = true
          // }
          
          isMin && !prev.end && (flag = true)
          prev.end && (flag = false)
          // console.log(flag, flag ? tomorrow : today)
          x.bookDateTime = (flag ? tomorrow : today) + ' ' + x.bookDate
        }

        x.passed = NOW > new Date(x.bookDateTime).getTime() // 当前时间已经过了
      }

      // this.bookDays = this.bookConfig_m.bookTimeList.map(x1 => {
      //   if (1)
      //   x1.bookDateTime = today + ' ' + x1.bookDate
      //   return x1
      // })
    },
  },
  // created() {
  //   this.initPage()
  // },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/util_dialog.scss';
.mydialog{
  margin: 20px 40px 0;overflow: hidden scroll;max-height: 330px;
  .row{min-height: 60px;}
}
</style>